"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.raf = void 0;
exports.removeFromArray = removeFromArray;
exports.isNullOrUndefined = isNullOrUndefined;
exports.valuesIter = valuesIter;
exports.numberRangeIterator = numberRangeIterator;
exports.getNumberRange = getNumberRange;
exports.elementRangeToChunkRange = elementRangeToChunkRange;
exports.iterateOverChunksIter = iterateOverChunksIter;
exports.settled = settled;
exports.fin = fin;
exports.allSettled = allSettled;
exports.getChunkFromArray = getChunkFromArray;
exports.rafTimeout = rafTimeout;
exports.delay = delay;
exports.createInterval = createInterval;
exports.subscribeToEvent = subscribeToEvent;
exports.getClosestNumber = getClosestNumber;
exports.getEnvironment = getEnvironment;
var Deferred_1 = require("./Deferred");
function removeFromArray(value, array) {
    var elementIndex = array.indexOf(value);
    if (elementIndex === -1) {
        return;
    }
    array.splice(elementIndex, 1);
}
function isNullOrUndefined(value) {
    return typeof value === "undefined" || value === null;
}
function valuesIter(arr) {
    var arr_1, arr_1_1, el, e_1_1;
    var e_1, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 5, 6, 7]);
                arr_1 = __values(arr), arr_1_1 = arr_1.next();
                _b.label = 1;
            case 1:
                if (!!arr_1_1.done) return [3 /*break*/, 4];
                el = arr_1_1.value;
                return [4 /*yield*/, el];
            case 2:
                _b.sent();
                _b.label = 3;
            case 3:
                arr_1_1 = arr_1.next();
                return [3 /*break*/, 1];
            case 4: return [3 /*break*/, 7];
            case 5:
                e_1_1 = _b.sent();
                e_1 = { error: e_1_1 };
                return [3 /*break*/, 7];
            case 6:
                try {
                    if (arr_1_1 && !arr_1_1.done && (_a = arr_1.return)) _a.call(arr_1);
                }
                finally { if (e_1) throw e_1.error; }
                return [7 /*endfinally*/];
            case 7: return [2 /*return*/];
        }
    });
}
function numberRangeIterator(start, count) {
    var i;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (count < 0) {
                    throw new Error("Count must be zero or greater.");
                }
                i = start;
                _a.label = 1;
            case 1:
                if (!(i < start + count)) return [3 /*break*/, 4];
                return [4 /*yield*/, i];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3:
                i++;
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/];
        }
    });
}
function getNumberRange(start, count) {
    return Array.from(numberRangeIterator(start, count));
}
function elementRangeToChunkRange(chunkSize, elementRange) {
    var chunkIndex = Math.floor(elementRange.start / chunkSize);
    var endChunk = Math.ceil(elementRange.end / chunkSize);
    var chunkCount = endChunk - chunkIndex;
    var startOffset = elementRange.start - chunkIndex * chunkSize;
    return {
        chunkIndex: Math.max(chunkIndex, 0),
        chunkSize: chunkSize,
        chunkCount: Math.max(chunkCount, 0),
        startOffset: Math.max(startOffset, 0),
    };
}
function iterateOverChunksIter(elementRange, chunkSize, chunkProvider) {
    var chunkRange, chunkIndices, elementsIterated, isFirst, chunk, currentElement;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                chunkRange = elementRangeToChunkRange(chunkSize, elementRange);
                chunkIndices = __spreadArray([], __read(getNumberRange(chunkRange.chunkIndex, chunkRange.chunkCount)), false);
                elementsIterated = 0;
                isFirst = true;
                _a.label = 1;
            case 1:
                if (!(chunkIndices.length > 0)) return [3 /*break*/, 5];
                chunk = chunkProvider(chunkIndices.shift(), isFirst ? chunkRange.startOffset : 0);
                isFirst = false;
                currentElement = chunk.next();
                _a.label = 2;
            case 2:
                if (!!currentElement.done) return [3 /*break*/, 4];
                return [4 /*yield*/, currentElement.value];
            case 3:
                _a.sent();
                elementsIterated++;
                if (elementsIterated === elementRange.end - elementRange.start) {
                    return [2 /*return*/];
                }
                currentElement = chunk.next();
                return [3 /*break*/, 2];
            case 4: return [3 /*break*/, 1];
            case 5: return [2 /*return*/];
        }
    });
}
function settled(promise) {
    return __awaiter(this, void 0, void 0, function () {
        var reason_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, promise];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    reason_1 = _a.sent();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/, Promise.resolve()];
            }
        });
    });
}
/**
 * From es2018.d.ts:
 *
 * Attaches a callback that is invoked when the Promise is settled (fulfilled or rejected). The
 * resolved value cannot be modified from the callback.
 *
 * @param promise The promise to attach the callback to.
 * @param onFinally The callback to execute when the Promise is settled (fulfilled or rejected).
 * @returns A Promise for the completion of the callback.
 */
function fin(promise, onFinally) {
    // `then` usually passes the type of the return value of the handler,
    // but the es2018 `finally` spec does not support a return value.
    return promise.then(onFinally, onFinally);
}
function allSettled(promises) {
    return Promise.all(promises.map(settled));
}
function getChunkFromArray(arr, chunkSize, chunkIndex) {
    var start = chunkSize * chunkIndex;
    var end = start + chunkSize;
    return arr.slice(start, end);
}
var rafFunc = !(typeof window === "undefined") &&
    /* istanbul ignore next */
    (window.requestAnimationFrame ||
        /* istanbul ignore next */
        window.webkitRequestAnimationFrame ||
        /* istanbul ignore next */
        window.mozRequestAnimationFrame);
// The function needs to be bound to window for IE/Edge.
exports.raf = rafFunc
    ? /* istanbul ignore next */
        rafFunc.bind(window)
    : /* istanbul ignore next */
        function (cb) { return setTimeout(function () { return cb(performance.now()); }); };
var TimeoutManager = /** @class */ (function () {
    function TimeoutManager() {
        var _this = this;
        this._timeouts = [];
        this._rafCallback = function () {
            var e_2, _a, e_3, _b;
            var now = performance.now();
            var toRemove = [];
            try {
                for (var _c = __values(_this._timeouts), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var timeout = _d.value;
                    // Early out if cancelled
                    if (timeout[2]) {
                        toRemove.push(timeout);
                        continue;
                    }
                    if (now > timeout[1]) {
                        try {
                            timeout[0]();
                        }
                        catch (e) {
                            // Any exceptions we catch here will be re-thrown as if it were unhandled.
                            // TODO: Test prohibitively difficult
                            /* istanbul ignore next */
                            setTimeout(function () {
                                /* istanbul ignore next */
                                throw e;
                            });
                        }
                        finally {
                            toRemove.push(timeout);
                        }
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_2) throw e_2.error; }
            }
            try {
                for (var toRemove_1 = __values(toRemove), toRemove_1_1 = toRemove_1.next(); !toRemove_1_1.done; toRemove_1_1 = toRemove_1.next()) {
                    var timeout = toRemove_1_1.value;
                    var index = _this._timeouts.indexOf(timeout);
                    if (index !== -1) {
                        _this._timeouts.splice(index, 1);
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (toRemove_1_1 && !toRemove_1_1.done && (_b = toRemove_1.return)) _b.call(toRemove_1);
                }
                finally { if (e_3) throw e_3.error; }
            }
            if (_this._timeouts.length > 0) {
                (0, exports.raf)(_this._rafCallback);
            }
        };
    }
    TimeoutManager.prototype.setTimeout = function (callback, timeoutMs) {
        if (timeoutMs === void 0) { timeoutMs = 0; }
        var now = performance.now();
        var timeout = [callback, now + timeoutMs, false];
        this._timeouts.push(timeout);
        if (this._timeouts.length === 1) {
            (0, exports.raf)(this._rafCallback);
        }
        return function () {
            timeout[2] = true;
        };
    };
    return TimeoutManager;
}());
var timeoutManager = new TimeoutManager();
function rafTimeout(callback, timeoutMs) {
    return { dispose: timeoutManager.setTimeout(callback, timeoutMs) };
}
// TODO: Try this with setTimeout instead of refTimeout
function delay(durationMs) {
    if (durationMs === void 0) { durationMs = 0; }
    var deferred = new Deferred_1.Deferred();
    rafTimeout(function () {
        deferred.resolve();
    }, durationMs);
    return deferred.promise;
}
function createInterval(callback, timeoutMs) {
    var handle = setInterval(callback, timeoutMs);
    return {
        dispose: function () {
            clearInterval(handle);
        },
    };
}
function subscribeToEvent(target, addEventListener) {
    var typeInternal;
    var listenerInternal;
    var optionsInternal;
    addEventListener(function (type, listener, options) {
        typeInternal = type;
        listenerInternal = listener;
        optionsInternal = options;
        target.addEventListener(type, listener, options);
    });
    return {
        dispose: function () {
            target.removeEventListener(typeInternal, listenerInternal, optionsInternal);
        },
    };
}
function getClosestNumber(targetNumber, numbers) {
    return numbers.map(function (n) { return [n, Math.abs(targetNumber - n)]; }).sort(function (a, b) { return a[1] - b[1]; })[0][0];
}
/* istanbul ignore next */
function getEnvironment() {
    /* istanbul ignore next */
    var isProduction = 
    /* istanbul ignore next */
    process.env.NODE_ENV !== "test" /* istanbul ignore next */ && process.env.NODE_ENV !== "development";
    /* istanbul ignore next */
    var profilingEnabled = 
    /* istanbul ignore next */
    !!process.env.SEARCH_PROFILING_ENABLED;
    return { isProduction: isProduction, profilingEnabled: profilingEnabled };
}
//# sourceMappingURL=Utilities.js.map